/**
 * mmc_legal_modal.js
 * Modal for displaying Privacy Policy and Terms.
 */

import React from 'react';
import { X } from '@phosphor-icons/react';
import { LEGAL_CONTENT } from './legal_content';
import { MmcButton } from './ui';

const MmcLegalModal = ({ type, isOpen, onClose }) => {
    if (!isOpen || !type) return null;

    const data = LEGAL_CONTENT[type];

    return (
        <div style={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'rgba(0,0,0,0.8)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            zIndex: 11000,
            padding: '16px',
            paddingTop: 'env(safe-area-inset-top, 16px)',
            paddingBottom: 'env(safe-area-inset-bottom, 16px)'
        }} onClick={onClose}>
            <div
                style={{
                    backgroundColor: 'var(--mmc-clr-white)',
                    color: 'var(--mmc-clr-bg)',
                    border: 'var(--mmc-b-width) solid var(--mmc-clr-black)',
                    boxShadow: '12px 12px 0px var(--mmc-clr-black)',
                    width: '100%',
                    maxWidth: '800px',
                    maxHeight: 'calc(100vh - 64px)',
                    maxHeight: 'calc(100dvh - 64px)',
                    display: 'flex',
                    flexDirection: 'column',
                    animation: 'mmc-modal-in 0.3s cubic-bezier(0.16, 1, 0.3, 1)'
                }}
                onClick={e => e.stopPropagation()}
                role="dialog"
                aria-modal="true"
                aria-labelledby="legal-title"
            >
                <div style={{
                    padding: 'var(--mmc-sp-16) var(--mmc-sp-24)',
                    borderBottom: 'var(--mmc-b-width) solid var(--mmc-clr-black)',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                    background: 'var(--mmc-clr-bg)',
                    color: 'var(--mmc-clr-white)'
                }}>
                    <h2 id="legal-title" style={{ textTransform: 'uppercase', margin: 0, fontSize: '1.2rem', color: 'var(--mmc-clr-white)' }}>{data.title}</h2>
                    <button onClick={onClose} aria-label="Close" style={{ display: 'flex', alignItems: 'center' }}>
                        <X size={24} weight="bold" />
                    </button>
                </div>

                <div style={{
                    padding: 'var(--mmc-sp-24)',
                    overflowY: 'auto',
                    flex: 1,
                    lineHeight: '1.6'
                }}>
                    <p style={{ color: 'var(--mmc-clr-text-muted)', fontSize: '0.8rem', marginBottom: '24px' }}>
                        Last updated: {data.lastUpdated}
                    </p>
                    <div
                        className="mmc-legal-html"
                        dangerouslySetInnerHTML={{ __html: data.content }}
                    />
                </div>

                <div style={{
                    padding: 'var(--mmc-sp-16) var(--mmc-sp-24)',
                    borderTop: 'var(--mmc-b-width) solid var(--mmc-clr-black)',
                    textAlign: 'right',
                    background: 'var(--mmc-clr-white)'
                }}>
                    <MmcButton variant="primary" onClick={onClose} style={{ width: window.innerWidth < 640 ? '100%' : 'auto' }}>Close</MmcButton>
                </div>
            </div>

            <style>{`
                @keyframes mmc-modal-in {
                    from { transform: scale(0.9) translateY(20px); opacity: 0; }
                    to { transform: scale(1) translateY(0); opacity: 1; }
                }
                .mmc-legal-html h3 {
                    text-transform: uppercase;
                    margin-top: 1.5rem;
                    margin-bottom: 0.5rem;
                    font-size: 1.1rem;
                }
                .mmc-legal-html p {
                    margin-bottom: 1rem;
                    font-size: 0.95rem;
                }
                @media (max-width: 640px) {
                    .mmc-legal-html h3 { font-size: 1rem; }
                    .mmc-legal-html p { font-size: 0.85rem; }
                }
            `}</style>
        </div>
    );
};

export default MmcLegalModal;
